import { isEqual } from 'lodash'

import { components, proxy } from '@/utils'

import render from './render'

export default {
  name: components.radio,

  mixins: [ proxy() ],

  props: {
    label: {
      type: [ String, Number ],
      default: undefined
    },

    color: {
      type: String,
      default: 'primary'
    },
    outline: {
      type: Boolean,
      default: false
    },

    disabled: Boolean
  },

  computed: {
    $_id() {
      return `${components.radio}-${this._uid}`
    },

    isChecked() {
      return isEqual(this.proxy, this.defaultValue)
    },

    classes() {
      return {
        [components.radio]: true,
        [`${components.radio}--outline`]: this.outline,
        [`${components.radio}--checked`]: this.isChecked,
        [`${components.radio}--disabled`]: this.isDisabled,
        [`${components.radio}--${this.color}`]: true
      }
    }
  },

  methods: {
    clickHandler() {
      if (!this.disabled) {
        this.proxy = this.defaultValue
      }
    },

    _inputHandler() {
      this.proxy = this.defaultValue
    }
  },

  render
}
